<template>
  <DetailTemplate
    :custom-class="'review-detail detail-page'"
    v-if="getPermission('reviews:view')"
  >
    <template v-slot:sidebar-detail>
      <div class="mt-5">
        <table width="100%">
          <tr>
            <td
              valign="middle"
              style="width: 95px"
              class="py-1 font-size-18 font-weight-500"
            >
              Review #
            </td>
            <td valign="middle" class="py-1 font-size-18">
              <div v-if="reviewData && reviewData.barcode">
                <Barcode :barcode="reviewData.barcode"></Barcode>
              </div>
            </td>
          </tr>
          <tr>
            <td
              valign="middle"
              style="width: 95px"
              class="py-1 font-size-18 font-weight-500"
            >
              Job #
            </td>
            <td valign="middle" class="py-1 font-size-18">
              <div v-if="reviewData && reviewData.visit">
                <Barcode
                  route="visit.detail"
                  :id="reviewData.visit.id"
                  :barcode="reviewData.visit.barcode"
                ></Barcode>
              </div>
            </td>
          </tr>
          <tr>
            <td valign="top" class="py-1 font-size-18 font-weight-500">
              Customer
            </td>
            <td valign="middle" class="py-1 font-size-18">
              <router-link
                v-if="reviewData.customer && reviewData.customer.id"
                :to="
                  getDefaultRoute('admin.customer.detail', {
                    params: {
                      id: reviewData.customer.id,
                    },
                  })
                "
              >
                <v-chip
                  small
                  color="blue darken-4"
                  class="cursor-pointer"
                  outlined
                  label
                >
                  {{ reviewData.customer.display_name }}
                </v-chip>
              </router-link>
            </td>
          </tr>
          <tr>
            <td valign="top" class="py-1 font-size-18 font-weight-500">
              Review Date
            </td>
            <td valign="middle" class="py-1 font-size-18">
              <span style="color: #24326d !important">
                {{ formatDateTime(reviewData.added_at) }}
              </span>
            </td>
          </tr>
        </table>
      </div>

      <!-- Job Information Section -->
      <div class="mt-5" v-if="reviewData.visit">
        <v-flex md12>
          <table width="100%">
            <tr>
              <th
                colspan="3"
                class="grey lighten-4 font-size-19 color-custom-blue py-1"
              >
                Visit Information
              </th>
            </tr>
            <tr>
              <td
                valign="middle"
                width="100px"
                class="py-1 font-size-18 font-weight-500"
              >
                Title
              </td>
              <td align="center" class="py-1" width="20px">:</td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="reviewData.visit">
                  {{ reviewData.visit.title || "N/A" }}
                </label>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Start Date
              </td>
              <td align="center" class="py-1">:</td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="reviewData.visit">
                  {{ formatDateTime(reviewData.visit.started_at) }}
                </label>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                End Date
              </td>
              <td align="center" class="py-1">:</td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0" v-if="reviewData.visit">
                  {{ formatDateTime(reviewData.visit.finished_at) }}
                </label>
              </td>
            </tr>
          </table>
        </v-flex>
      </div>

      <!-- Site Location -->
      <div class="mt-5">
        <v-flex md12>
          <table width="100%">
            <tr>
              <th
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Site Location
              </th>
            </tr>
            <tr>
              <td class="py-0 font-size-18 py-2">
                <template
                  v-if="
                    reviewData.ticket &&
                    (reviewData?.ticket?.property?.property_name ||
                      reviewData?.ticket?.property?.property_address)
                  "
                >
                  <div
                    class="custom-flex-d"
                    v-if="reviewData?.ticket?.property?.property_name"
                  >
                    <b>
                      <v-icon
                        style="font-size: 18px; margin-top: -3px"
                        class="cmt-2"
                      >
                        mdi-home-map-marker
                      </v-icon>
                    </b>
                    <span
                      >{{ reviewData?.ticket?.property?.property_name }}<br
                    /></span>
                  </div>
                  <div v-else>
                    <em class="text-muted">
                      <v-icon
                        style="font-size: 18px; margin-top: -3px"
                        class="cmt-2"
                      >
                        mdi-home-map-marker
                      </v-icon>
                      No Site Name
                    </em>
                  </div>
                  <div class="custom-flex-d">
                    <b>
                      <v-icon
                        style="font-size: 18px; margin-top: -3px"
                        class="cmt-2"
                      >
                        mdi-map-marker
                      </v-icon>
                    </b>
                    <span>
                      {{
                        reviewData.ticket.property.property_address ||
                        "No address available"
                      }}
                    </span>
                  </div>
                </template>

                <template v-else>
                  <em class="text-muted">
                    <v-icon
                      style="font-size: 18px; margin-top: -3px"
                      class="cmt-2"
                    >
                      mdi-home-map-marker
                    </v-icon>
                    Site not available right now
                  </em>
                </template>
              </td>
            </tr>

            <tr>
              <th
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Customer Contact Details
              </th>
            </tr>

            <tr v-if="reviewData.customer">
              <td class="py-0 font-size-18">
                <v-icon small class="mr-2"> mdi-phone </v-icon>
                {{ reviewData.customer.company_number }}
              </td>
            </tr>
            <tr v-if="reviewData.customer">
              <td class="py-0 font-size-18">
                <v-icon small class="mr-2"> mdi-email </v-icon>
                {{ reviewData.customer.company_email }}
              </td>
            </tr>
          </table>
        </v-flex>
      </div>
    </template>

    <template v-slot:header-title>
      <h1
        class="form-title custom-nowrap-ellipsis text-capitalize mr-2 font-weight-700"
        v-if="reviewData.visit && reviewData.visit.title"
      >
        Review: {{ reviewData.barcode }} /
        {{ reviewData.visit?.title }}
      </h1>
    </template>

    <template v-slot:header-action>
      <div class="d-flex align-center justify-end flex-wrap" v-if="pageLoaded">
        <v-menu
          transition="slide-y-transition"
          bottom
          content-class="custom-menu-list"
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }"> </template>
          <v-list>
            <v-list-item
              link
              v-on:click="exportReview()"
              :disabled="statusLoading"
            >
              <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                <v-icon class="icon-default-blue">mdi-download</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-500 font-size-14">
                Export Review
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn
          depressed
          class="mx-2 mb-1 custom-grey-border custom-bold-button"
          v-on:click="goBack()"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </div>
    </template>

    <template v-slot:body>
      <v-container fluid class="">
        <v-row v-if="pageLoaded">
          <v-col md="12" class="py-0">
            <!-- Only Overview Tab Content -->
            <v-container fluid class="px-0">
              <v-row>
                <v-col md="6">
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4 h-100"
                  >
                    <v-card-title class="headline grey lighten-4 py-1">
                      <span
                        class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                      >
                        Review Information
                      </span>
                    </v-card-title>

                    <v-card-text class="p-6 font-size-16">
                      <table width="100%">
                        <tr>
                          <td
                            width="180px"
                            class="py-1 font-size-18 font-weight-500"
                          >
                            Overall Experience
                          </td>
                          <td align="center" width="20px">:</td>
                          <td class="py-1 font-size-18">
                            {{ reviewData.overall_satisfaction }}
                          </td>
                        </tr>

                        <tr>
                          <td class="py-1 font-size-18 font-weight-500">
                            Expectations
                          </td>
                          <td align="center">:</td>
                          <td class="py-1 font-size-18">
                            {{ reviewData.expectations }}
                          </td>
                        </tr>

                        <tr>
                          <td class="py-1 font-size-18 font-weight-500">
                            Service Quality
                          </td>
                          <td align="center">:</td>
                          <td class="py-1 font-size-18">
                            {{ reviewData.service_quality }}
                          </td>
                        </tr>

                        <tr>
                          <td class="py-1 font-size-18 font-weight-500">
                            Value For Money
                          </td>
                          <td align="center">:</td>
                          <td class="py-1 font-size-18">
                            {{ reviewData.value_for_money }}
                          </td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col md="6">
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4 h-100"
                  >
                    <v-card-title class="headline grey lighten-4 py-1">
                      <span
                        class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                      >
                        Additional Information
                      </span>
                    </v-card-title>

                    <v-card-text class="p-6 font-size-16">
                      <table width="100%">
                        <tr>
                          <td
                            width="180px"
                            class="py-1 font-size-18 font-weight-500"
                          >
                            Customer Support
                          </td>
                          <td align="center">:</td>
                          <td class="py-1 font-size-18">
                            {{ reviewData.customer_support }}
                          </td>
                        </tr>

                        <tr>
                          <td class="py-1 font-size-18 font-weight-500">
                            Issue Resolved
                          </td>
                          <td align="center">:</td>
                          <td class="py-1 font-size-18">
                            {{ reviewData.issue_resolved }}
                          </td>
                        </tr>

                        <tr>
                          <td class="py-1 font-size-18 font-weight-500">
                            Loyalty Recommendation
                          </td>
                          <td align="center">:</td>
                          <td class="py-1 font-size-18">
                            {{
                              reviewData.loyalty_recomm !== null
                                ? `${reviewData.loyalty_recomm}/10`
                                : "-"
                            }}
                          </td>
                        </tr>

                        <tr>
                          <td class="py-1 font-size-18 font-weight-500">
                            Use Again
                          </td>
                          <td align="center">:</td>
                          <td class="py-1 font-size-18">
                            {{ reviewData.use_again }}
                          </td>
                        </tr>

                        <tr
                          v-if="
                            reviewData.updated_at &&
                            reviewData.updated_at !== reviewData.added_at
                          "
                        >
                          <td class="py-1 font-size-18 font-weight-500">
                            Last Updated
                          </td>
                          <td align="center">:</td>
                          <td class="py-1 font-size-18">
                            {{ formatDateTime(reviewData.updated_at) }}
                          </td>
                        </tr>

                        <tr v-if="reviewData.user">
                          <td class="py-1 font-size-18 font-weight-500">
                            Added By
                          </td>
                          <td align="center">:</td>
                          <td class="py-1 font-size-18">
                            {{ reviewData.user.display_name || "System" }}
                          </td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-card flat class="custom-grey-border remove-border-radius mb-4">
                <v-card-title class="grey lighten-4">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue font-size-16"
                    >What did you like most about your experience ?</span
                  >
                </v-card-title>
                <v-card-text class="p-6 font-size-16">
                  <read-more
                    class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                    more-str="read more"
                    :text="reviewData.liked_most || '<em>No Description</em>'"
                    link="#"
                    less-str="read less"
                    :max-chars="200"
                  >
                  </read-more>
                </v-card-text>
              </v-card>
              <v-card flat class="custom-grey-border remove-border-radius mb-4">
                <v-card-title class="headline grey lighten-4">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue font-size-16"
                    >What can we improve ?</span
                  >
                </v-card-title>
                <v-card-text class="p-6 font-size-16">
                  <read-more
                    class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                    more-str="read more"
                    :text="reviewData.improvement || '<em>No Description</em>'"
                    link="#"
                    less-str="read less"
                    :max-chars="200"
                  >
                  </read-more>
                </v-card-text>
              </v-card>
              <v-card flat class="custom-grey-border remove-border-radius mb-4">
                <v-card-title class="headline grey lighten-4">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue font-size-16"
                    >Any additional comments or suggestions ?</span
                  >
                </v-card-title>
                <v-card-text class="p-6 font-size-16">
                  <read-more
                    class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                    more-str="read more"
                    :text="reviewData.comment || '<em>No Description</em>'"
                    link="#"
                    less-str="read less"
                    :max-chars="200"
                  >
                  </read-more>
                </v-card-text>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </v-container>

      <!-- Loaded State -->
      <v-container v-if="pageLoaded" fluid class="pa-4">
        <!-- actual content here -->
      </v-container>

      <!-- Loading State -->
      <v-container
        v-else
        fluid
        class="d-flex justify-center align-center"
        style="min-height: 400px"
      >
        <v-progress-circular
          :size="70"
          :width="7"
          color="cyan"
          indeterminate
        ></v-progress-circular>
      </v-container>
    </template>
  </DetailTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import moment from "moment";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import Barcode from "@/view/pages/partials/Barcode.vue";
import JwtService from "@/core/services/jwt.service";

export default {
  name: "ReviewDetail",
  mixins: [CommonMixin],
  components: {
    DetailTemplate,
    Barcode,
  },
  data() {
    return {
      reviewData: {},
      pageLoaded: false,
      statusLoading: false,
      reviewId: null,
    };
  },
  created() {
    this.reviewId = this.$route.params.id;
    this.getReviewDetail();
  },
  computed: {
    filteredVisits() {
      return Array.isArray(this.reviewData?.ticket?.visit)
        ? this.reviewData.ticket.visit.filter((v) => v && v.barcode)
        : [];
    },
  },
  methods: {
    async getReviewDetail() {
      try {
        this.statusLoading = true;

        // Replace with your actual API endpoint
        const response = await this.$http.get(`reviews/${this.reviewId}`);

        if (response.data.success) {
          this.reviewData = response.data.data;
          this.pageLoaded = true;
        } else {
          this.$notify.error("Failed to load review details");
        }
      } catch (error) {
        console.error("Error fetching review:", error);
        this.$notify.error("Error loading review details");
      } finally {
        this.statusLoading = false;
      }
    },

    formatDateTime(date) {
      if (!date) return "-";

      return moment(date).format("DD/MM/YYYY hh:mm A");
    },

    // getPermission(permission) {
    //   // Implement your permission check logic
    //   return true;
    // },

    getDefaultRoute(routeName, params = {}) {
      return {
        name: routeName,
        ...params,
      };
    },

    getRatingColor(rating) {
      if (rating >= 4) return "green";
      if (rating >= 3) return "orange";
      return "red";
    },

    formatDateStartTime(date) {
      if (!date) return "";
      return new Date(date).toLocaleTimeString();
    },

    goBack() {
      this.$router.go(-1);
    },

    // editReview() {
    //   // Implement edit review logic
    //   this.$router.push(`/reviews/${this.reviewId}/edit`);
    // },

    // deleteReview() {
    //   // Implement delete review logic
    //   if (confirm("Are you sure you want to delete this review?")) {
    //     // Add your delete API call here
    //     console.log("Delete review:", this.reviewId);
    //   }
    // },

    exportReview() {
      try {
        let downloadURL = process.env.VUE_APP_API_URL + "reviews/export";
        downloadURL = new URL(downloadURL);

        // Get token from multiple possible sources
        const token =
          this.$store.getters.getToken ||
          JwtService.getToken() ||
          localStorage.getItem("token") ||
          localStorage.getItem("jwt_token");

        if (!token) {
          this.$notify.error(
            "Authentication token not found. Please login again."
          );
          return;
        }

        downloadURL.searchParams.append("token", token);
        downloadURL.searchParams.append("review_id", this.reviewId);

        console.log("Export URL:", downloadURL.toString());

        const link = document.createElement("a");
        link.href = downloadURL.toString();
        link.target = "_blank";
        link.download = `review_${this.reviewId}_export.xlsx`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$notify.success("Export started successfully");
      } catch (error) {
        console.error("Export error:", error);
        this.$notify.error("Failed to export review");
      }
    },
  },
};
</script>
